import React from "react";
import { Card, Stack, CardMedia, Typography } from "@mui/material";

export default function Attachments({ label, media }) {
  return (
    <Card sx={{ width: "100%" }}>
      <CardMedia
        image={media?.full_url || "/assets/images/picture.png"}
        sx={{ height: 120, position: "relative" }}
      >
        <Stack
          top={0}
          left={0}
          right={0}
          bottom={0}
          position="absolute"
          justifyContent="space-between"
        >
          <Stack p={1} flexGrow={1} alignItems="center" justifyContent="center">
            {!media?.full_url && <Typography variant="caption" color="textSecondary">
              {label}
            </Typography>}
          </Stack>
        </Stack>
      </CardMedia>
    </Card>
  );
}
